"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const XMLNS = 'http://www.w3.org/2000/svg';
exports.XMLNS = XMLNS;
//# sourceMappingURL=xmlns.js.map